<template>
  <div class="doses-list">
    <h4>{{ title }}:</h4>
    <div
      class="doses-list-item"
      v-for="n in doses.length"
      :key="n"
      :class="doses[n - 1].cor"
    >
      <strong
        >{{ doses[n - 1].dose }}
        <span
          v-if="doses[n - 1].dose_anterior == 1"
          v-b-tooltip.hover.right
          title="Dose registrada como transcrição de caderneta."
          class="icon-tooltip"
        >
          <i class="icofont-info-circle"></i> </span
      ></strong>
      <span>
        {{ doses[n - 1].dt_aplicacao_br }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemDoses',
  props: {
    title: {
      type: String,
      default: '',
    },
    doses: {
      type: [Array, Boolean],
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
.doses-list {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
  gap: 20px;
  margin: 20px 0;
  background-color: #f1f0f5;
  padding: 15px;
  h4 {
    font-size: 16px;
    margin-bottom: 0;
    width: 15%;
  }
  .doses-list-item {
    background-color: #fff;
    min-width: 120px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 10px;
    border: 1px solid #ccc;
    color: #000;
    border-radius: 6px;
    &.red {
      background: #ffb3b3 !important;
      // border-color: #990000 !important;
    }
    &.green {
      background: #b3ffb3;
      // border-color: #008000 !important;
    }
    &.white {
      background: #fff;
      // border-color: #000 !important;
    }
  }
}
</style>
